// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__13wcr","toggleButton":"Toggle_toggleButton__bnybU"};